var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.productImage)?_c('div',{staticClass:"wl-card__slider__image overflow-hidden",class:_vm.slide === _vm.id ? 'wl-card__slider__image--active' : ''},[_c('img',{attrs:{"src":_vm.productImage}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }